<template>
   <div class="nav">
        <img @click="toggleMenu" class="burger-button"
          src="../assets/BurgerButton.svg"
          alt="Menu" />
     <div class="title">Flugbuch</div>
     <div class="logout" @click="logout" >Abmelden</div>
   </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
    name: 'Navbar',
    setup(props, context) {
        const router = useRouter()
        const store = useStore()
        const logout = () => {
            store.dispatch('logout')
            router.push({ name: "Login" })
        }
        
        const toggleMenu = () => {
          context.emit('toggleMenu');
        }     
        return{logout, toggleMenu}
    }
}

</script>

<style scoped>
.nav {
    background: #444;
    color: #fff;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 5px solid crimson;
    height: 50px; 
}

.title {
    font-size: 18px; 
    padding: 0 12px;
    margin: 0px;
    color:white;
    font-weight: bold;
}

.logout{
    padding: 0 12px;
    margin:0px;
}

.burger-button {
  width: 26px;
  height: 26px;
  margin: 0px 15px; 
}


</style>